// extracted by mini-css-extract-plugin
module.exports = {"ParcelTags":"ParcelTags_ParcelTags__2JhA-","coordinates":"ParcelTags_coordinates__3Vw4t"};